import { useEffect, useState } from "react";

// Presentation-only constraint. It never overwrites manual navigation state.
export function useNarrowNavigation(enabled) {
  const [narrow, setNarrow] = useState(false);
  useEffect(() => {
    if (!enabled || typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia("(max-width: 860px)");
    const update = () => setNarrow(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [enabled]);
  return Boolean(enabled && narrow);
}
